var map = {
	"./01-capsule-0-base.svg": "5043",
	"./01-capsule-1.svg": "e080",
	"./01-capsule-2.svg": "ff10",
	"./01-capsule-3-base.svg": "1468",
	"./02-ball-1.svg": "629f",
	"./02-ball-2.svg": "ae13",
	"./02-egg-1-base.svg": "be71",
	"./02-egg-3-base.svg": "1a22",
	"./03-ball-1-base.svg": "33b1",
	"./03-round-not-convex-1.svg": "f805",
	"./03-round-not-convex-2.svg": "d154",
	"./04-round-convex-1.svg": "7e80",
	"./04-round-convex-2.svg": "39c3",
	"./04-round-not-convex-1-base.svg": "5508",
	"./04-round-not-convex-3-base.svg": "ac6d",
	"./05-oval-not-convex-1.svg": "68e6",
	"./05-oval-not-convex-2.svg": "3917",
	"./05-oval-not-convex-3.svg": "be1a",
	"./05-round-convex-3-4-base.svg": "9d3c",
	"./06-oval-convex-1.svg": "3f1d",
	"./06-oval-convex-2.svg": "ee23",
	"./06-oval-convex-3.svg": "7f9c",
	"./06-oval-not-convex-1-2-base.svg": "0660",
	"./06-oval-not-convex-4-5-base.svg": "a418",
	"./06-oval-not-convex-7-base.svg": "bc8e",
	"./07-oval-convex-1-2-3-base.svg": "1ef8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59a0";